export default "__VITE_ASSET__TeKr0RCk__"